import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';
import heroBg from '../assets/img/ic_our_service_background.png';

export default function Hotel() {
  return (
    <div className="bg-navy-950">
      <PageHero
        title="Hotel"
        subtitle="Comfortable stays—from booking assistance to special requests."
        backgroundImage={heroBg}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-justify leading-relaxed text-white/80">
          We support hotel reservations and coordination so you can focus on your trip while we handle the details
          with trusted options that match your budget and preferences.
        </p>
      </section>
    </div>
  );
}
